module.exports = __webpack_public_path__ + "static/img/image_solutions_web_02.97ef842.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/resource/images/solution/image_solutions_web_02.png
// module id = UlKp
// module chunks = 10